import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Minus, Spot } from '@travel/icons/ui';
import { useDialogHandler } from '@travel/traveler-core/hooks';
import { IconText } from '@travel/ui';
import { cx } from '@travel/utils';

import ButtonNoStyle from 'components/ButtonNoStyle';
import LocationMap from 'components/LocationMap';
import { getItem } from 'store/providerInformation/selectors';

import { Translate } from 'core/translate';

import styles from './shortAddressWithMap.module.scss';

type Props = {
  /** parent page name for RAT popups */
  pageName: 'hotel:rooms_and_plans_dated_list' | 'hotel:rooms_and_plans_undated_list';
  wrapperClassName?: string;
};

function ShortAddressWithMap(props: Props) {
  const provider = useSelector(getItem);
  const { breadcrumb } = provider;

  const { isOpen: isOpenMap, onClose: onCloseMap, onOpen: onOpenMap } = useDialogHandler(false);

  const addressText = useMemo(() => {
    // example: Higashikurume, Tokyo
    const city = breadcrumb[2]?.name;
    const division = breadcrumb[1]?.name;

    const shouldShowComma = city && division;
    const shortAddress = shouldShowComma ? `${city}, ${division}` : city || division;

    return shortAddress;
  }, [breadcrumb]);

  return (
    <div
      className={cx(styles.wrapper, props.wrapperClassName)}
      data-testid="providerInformation-shortAddressWithMap-wrapper"
    >
      <IconText
        className={styles.address}
        text={addressText}
        spaceBetween={4}
        icon={<Spot size={16} />}
        data-testid="providerInformation-shortAddressWithMap-locationDetail"
      />
      <Minus color="default" />{' '}
      <ButtonNoStyle
        onClick={onOpenMap}
        data-testid="providerInformation-shortAddressWithMap-showOnMap"
        className={styles.showOnMap}
      >
        <Translate id="Provider_Info.Navigation.Show_on_Map" />
      </ButtonNoStyle>
      {isOpenMap && (
        <LocationMap
          pageName={props.pageName}
          item={provider}
          isOpen={isOpenMap}
          onClose={onCloseMap}
        />
      )}
    </div>
  );
}

export default ShortAddressWithMap;
